export default __webpack_public_path__ + "static/media/before-start.e67d5bef.svg";